import { FC } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'
import InfoIcon from 'src/Assets/Svg/common/info.svg?react'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  border-radius: 16px;
  width: 100%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const Message = styled.div`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

export const NotReviewedBanner: FC = () => (
  <Container>
    <InfoIcon />
    <Message>
      The funds reserved for this curator(s) will be returned to your balance.
    </Message>
  </Container>
)
